<template>
    <v-app>
        <v-app-bar color="amber-lighten-3">
            <template v-slot:prepend>
                <v-app-bar-nav-icon></v-app-bar-nav-icon>
            </template>
            <v-app-bar-title>Stone Creek</v-app-bar-title>
            <v-btn v-if="role" @click="userLogout">Logout</v-btn>
        </v-app-bar>

        <v-main>
            <dialog-login v-if="!role" @user-login="userLogin" />
            <div v-if="role">
                <side-bar @select-tab="selectTab" />
                <component :is="selectedTab"></component>
            </div>
        </v-main>
    </v-app>
</template>

<script>
import DialogLogin from './components/DialogLogin.vue';
import SideBar from './components/Sidebar.vue';

export default {
    name: 'App',
    components: {
        DialogLogin,
        SideBar,
    },
    mounted() {
        this.userLogin();
    },
    methods: {
        selectTab(newTab) {
            this.selectedTab = newTab;
            localStorage.setItem('CurrentPage', newTab)
        },
        userLogin() {

            let newRole = undefined;
            const authToken = localStorage.getItem('Auth');

            if (authToken) {
                fetch(`${process.env.VUE_APP_STONECREEK_BACKEND}/api/v2/servers`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${authToken}`,
                    },
                })
                .then((response) => {
                    if (!response.ok) throw new Error('Fetch failed');

                    newRole = 'admin';
                    this.role = newRole;
                })
                .catch((error) => {
                    this.userLogout();
                    console.error('Failed to load items:', error);
                });
            }

            this.role = newRole;
        },
        userLogout() {
            
            localStorage.removeItem('Auth');
            localStorage.removeItem('PlayerGuid');
            localStorage.removeItem('DiscordId');

            this.role = undefined;
        },
    },
    data: () => ({
        selectedTab: localStorage.getItem('CurrentPage') || 'page-item-database',
        role: undefined,
    }),
};
</script>
